import { useCallback } from "react";
import { SidePanelDS } from "@qivia/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../../redux/hooks";
import { selectLinkyConsents } from "../../linkyConsentsSlice";
import "../../../../../i18n/i18n";

export const DriverSidePanel = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const linkyConsents = useAppSelector(selectLinkyConsents);

  const driver =
    linkyConsents.find((consent) => consent.uuid === params.id) ?? null;

  const onSidePanelClosed = useCallback(() => {
    navigate(`/${firstPath}/electric_charging/linky_connections`);
  }, [firstPath, navigate]);

  if (!driver) {
    return;
  }

  return (
    <SidePanelDS.SidePanel visible={!!driver} onClose={onSidePanelClosed} />
  );
};
